import React, { useEffect } from "react";
import QuestionPublicLink from "../../component/PublicLink/PublicLink";
import QuizMarkdown from "../../component/Markdown/QuizMarkdown";
import { QuizDescriptionDiv, QuizScreen } from "../GeneralStyles";
import styled from "styled-components";

const TitleBase = styled.div`
  background-color: ${(props) => props.bgColor || "initial"};
  color: ${(props) => props.textColor || "initial"};
  border-radius: 10px;
  display:inline-block;
  padding: 8px;
  text-align: center;
  padding-inline:  calc( 8px + calc((1lh -  1ex) / 2));
`;

const QuizTitleH1 = styled(TitleBase).attrs({ as: 'h1' })``;
const QuizTitleH2 = styled(TitleBase).attrs({ as: 'h2' })``;
const QuizTitleH3 = styled(TitleBase).attrs({ as: 'h3' })``;
const QuizTitleH4 = styled(TitleBase).attrs({ as: 'h4' })``;
const QuizTitleH5 = styled(TitleBase).attrs({ as: 'h5' })``;
const QuizTitleH6 = styled(TitleBase).attrs({ as: 'h6' })``;

const titleComponents = {
  1: QuizTitleH1,
  2: QuizTitleH2,
  3: QuizTitleH3,
  4: QuizTitleH4,
  5: QuizTitleH5,
  6: QuizTitleH6,
};

const ResultTitle = ({ question, overViewPage, enableNavigationButton }) => {
  // Ensure title_size is a number between 1 and 6
  const validTitleSize = Math.min(Math.max(question.title_size, 1), 6);
  const QuizTitleTag = titleComponents[validTitleSize];

  // Use useEffect to call enableNavigationButton after component renders
  useEffect(() => {
    if (enableNavigationButton) {
      enableNavigationButton(); // Call after component has mounted
    }
  }, [enableNavigationButton]);

  return (
    <QuizScreen bgVisible={overViewPage} id={question.quiz_item_id}>
      <QuestionPublicLink overViewPage={overViewPage} type="question" quiz_item_id={question.quiz_item_id} />
      {question.title && (
        <QuizTitleTag bgColor={question.title_text_colour} textColor={question.title_colour}>
          {question.title}
        </QuizTitleTag>
      )}
      {question.description && (
        <QuizDescriptionDiv color={question.title_text_colour} bgColor={question.title_colour}>
          <QuizMarkdown>{question.description}</QuizMarkdown>
        </QuizDescriptionDiv>
      )}
    </QuizScreen>
  );
};

export default ResultTitle;
